import type { CSSProperties, ReactNode } from 'react';
import './ficha.css';

export type LinhaFicha = {
  rotulo: string;
  valor: ReactNode;
  /** Cadastrado, mas exige confirmação para ver: itálico e tom secundário. */
  protegido?: boolean;
  /** Não existe: "ainda não conversou". Itálico, mesmo tom, outro sentido. */
  vazio?: boolean;
  /**
   * A linha merece o olho: na comparação de identidade é o campo que difere
   * entre os dois cadastros. Vira `data-destaque` no rótulo e no valor; o que
   * o destaque significa e como se pinta é da tela, por contexto.
   */
  destaque?: boolean;
  /** `title` do valor — o instante por extenso atrás de "há 3 dias". */
  titulo?: string;
};

export type FichaProps = {
  linhas: LinhaFicha[];
  /** Largura da coluna de rótulo. Padrão 84px (o painel do atendimento). */
  larguraRotulo?: string;
  /** Valor à direita com dígito tabular: fichas de número comparado. */
  direita?: boolean;
  /** Rótulo sobre o valor: telas estreitas e rótulos longos. */
  empilhada?: boolean;
};

export function Ficha({ linhas, larguraRotulo, direita = false, empilhada = false }: FichaProps) {
  const classe = ['ficha', direita ? 'ficha--direita' : null, empilhada ? 'ficha--empilhada' : null]
    .filter(Boolean)
    .join(' ');

  const estilo = larguraRotulo ? ({ '--ficha-rotulo': larguraRotulo } as CSSProperties) : undefined;

  return (
    <dl className={classe} style={estilo}>
      {linhas.map((linha) => (
        <div key={linha.rotulo} style={{ display: 'contents' }}>
          <dt data-destaque={linha.destaque ? 'sim' : undefined}>{linha.rotulo}</dt>
          <dd data-destaque={linha.destaque ? 'sim' : undefined} title={linha.titulo}>
            {linha.protegido || linha.vazio ? (
              <span className={linha.protegido ? 'ficha__protegido' : 'ficha__vazio'}>
                {linha.valor}
              </span>
            ) : (
              linha.valor
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
